import { render } from "./TextImageBlock.vue?vue&type=template&id=cb921fa4"
import script from "./TextImageBlock.vue?vue&type=script&lang=js"
export * from "./TextImageBlock.vue?vue&type=script&lang=js"

import "./TextImageBlock.vue?vue&type=style&index=0&id=cb921fa4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__